<template>
    <section id="section3" class="columns is-multiline is-centered">
        <widget
            :width="4"
            v-for="attr in average_percentage_attributes"
            :key="attr.name"
        >
            <percentage-widget
                :title="`Average ${attr.name}`"
                :value="attr.value"
                :help="attr.help"
            />

            <div class="attribute_histogram">
                <histogram
                    :values="attr.graph"
                    :name="attr.name"
                    unit="%"
                    :step="0.1"
                />
            </div>
        </widget>
        <widget
            :width="4"
            v-for="attr in average_other_attributes"
            :key="attr.name"
            class="other_attr"
        >
            <div class="inner">
                <big-text-widget
                    :value="attr.value"
                    :title="attr.name"
                    :unit="attr.unit"
                    :help="attr.help"
                />
                <div class="attribute_histogram">
                    <histogram
                        :values="attr.graph"
                        :name="attr.name"
                        :unit="attr.unit"
                        :step="attr.step"
                    />
                </div>
            </div>
        </widget>
    </section>
</template>

<script>
import PercentageWidget from "../PercentageWidget";
import Widget from "../Widget";
import Histogram from "../Histogram";
import BigTextWidget from "../BigTextWidget";

export default {
    name: "attributes",
    props: ["dat"],
    components: { BigTextWidget, Histogram, Widget, PercentageWidget },
    computed: {
        average_percentage_attributes() {
            // Iterate over the different metrics
            let out = [];
            for (let attr of [
                "acousticness",
                "danceability",
                "energy",
                "instrumentalness",
                "liveness",
                "speechiness",
                "valence"
            ]) {
                out.push({
                    name: attr,
                    value: Math.round(this.dat.average_attributes[attr] * 100),
                    graph: this.dat.histogram[attr],
                    help: `The average ${attr} of your top 20 songs`
                });
            }
            return out;
        },
        average_other_attributes() {
            // Define the data for other attributes
            return [
                {
                    name: "loudness",
                    value: Math.round(this.dat.average_attributes.loudness),
                    graph: this.dat.histogram.loudness,
                    help: `The average loudness of your top 20 songs`,
                    unit: "db"
                },
                {
                    name: "tempo",
                    value: Math.round(this.dat.average_attributes.tempo),
                    graph: this.dat.histogram.tempo,
                    help: `The average tempo of your top 20 songs`,
                    unit: "bpm"
                }
            ];
        }
    }
};
</script>

<style scoped lang="scss">
.other_attr ::v-deep .widget {
    height: 100%;
    padding-top: 30%;
}
</style>
